import { ThemeProvider } from '@mui/material/styles';
import theme from "assets/jss/MyTheme";
import "assets/scss/material-kit-pro-react.css";
import hist from "history.js";
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Route, Router, Switch } from "react-router";
import { PersistGate } from "redux-persist/es/integration/react";
import { persistor, store } from "redux/store";
import Layout from "views/Layout/Layout";
// import ReactGA from 'react-ga4';
// ReactGA.initialize('G-NHE41HSRSK');

ReactDOM.render(

  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <ThemeProvider theme={theme}>
        <Router history={hist}>
          <Switch>
            <Route path='*' component={Layout} />
          </Switch>
        </Router>
      </ThemeProvider>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
